// extracted by mini-css-extract-plugin
export default {"testButton":"TestAction_testButton__g6iNM","disabled":"TestAction_disabled__fxUBR"};